import React, { useState } from "react";
import { PaginationWrapper } from "./style";
import { useMediaQuery } from "react-responsive";
const Pagination = () => {
  const tempArr = new Array(10).fill(0);
  const isPc = useMediaQuery({
    query: "(min-width:900px)",
  });
  const hoverHandler = (e) => {
    const url = e.target.src;
    e.target.src = url.replace(".svg", "green.svg");
  };
  const outHandler = (e) => {
    const url = e.target.src;
    e.target.src = url.replace("green.svg", ".svg");
  };
  return (
    <PaginationWrapper>
      <img
        loading="lazy"
        src="/assets/img/NewsEvents_5.svg"
        alt=""
        onMouseEnter={hoverHandler}
        onMouseOut={outHandler}
      />
      <img
        loading="lazy"
        src="/assets/img/NewsEvents_4.svg"
        alt=""
        onMouseEnter={hoverHandler}
        onMouseOut={outHandler}
      />
      {isPc
        ? tempArr.map((v, idx) => <span key={idx}>{idx + 1}</span>)
        : tempArr.map((v, idx) => <span key={idx}>{idx + 1}</span>).slice(0, 5)}

      <img
        loading="lazy"
        src="/assets/img/NewsEvents_6.svg"
        alt=""
        onMouseEnter={hoverHandler}
        onMouseOut={outHandler}
      />
      <img
        loading="lazy"
        src="/assets/img/NewsEvents_7.svg"
        alt=""
        onMouseEnter={hoverHandler}
        onMouseOut={outHandler}
      />
    </PaginationWrapper>
  );
};

export default Pagination;
